import React from "react";
import Box from "@mui/material/Box";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toast";
import { verifypayment } from "../apiCalls";
import { EVENTS } from "../../centralOms/events_constant";
import { logEventToAnalyticsPlatform } from "../../../helper/events";

export default function MoveToPickedDialog({
  moveToPickedDialogVisible,
  orderId,
  patientName,
  setMoveToPickedDialogVisibility,
  setNavigateToAll
}) {
  const updateRequest = async () => {
    try {
        const response = await verifypayment(orderId);
        if(response.success){
            logEventToAnalyticsPlatform({
              name: EVENTS.PC_LS_ACTION.name,
              payload: {
                tab_name: EVENTS.TAB_NAME_MANUFACTURING,
                filterValue: 'true',
                reference_id: '' + orderId,
                reference_provider_id: '',
                service_name: EVENTS.SERVICE_NAME_VISION,
                action: EVENTS.ACTION.START_PRODUCTION_CLICKED,
              },
              schema: EVENTS.PC_LS_ACTION.schema,
            });
            setMoveToPickedDialogVisibility(false);
            setNavigateToAll(true);
        } else {
            toast.error('Request update failed');
        }
    } catch (err) {
      toast.error(`Request update failed - ${err?.response?.data?.error}`);
    }
  };

  return (
    <Dialog open={moveToPickedDialogVisible} onClose={() => setMoveToPickedDialogVisibility(false)} fullWidth={true} maxWidth={"sm"}>
      <DialogTitle style={{ background: "rgb(245 245 245)" }}>
        <div className="flex justify-between">
          <div className="font-semibold">
            <span className="cursor-pointer">Start Production</span>
            <div className="text-xs text-gray-500">
              Order ID: <span className="font-semibold">{orderId} </span>
            </div>
            <div className="text-xs text-gray-500">
              Patient Name: <span className="font-semibold">{patientName} </span>
            </div>
          </div>
          <div className="text-gray-500" onClick={() => setMoveToPickedDialogVisibility(false)}>
            <span className="cursor-pointer">
              <CloseIcon></CloseIcon>
            </span>
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        <Box className="mt-5">
          <div className="pb-5 flex justify-between text-center">
            <div
              className="border border-gray-600 rounded-md w-40 text-gray-900 p-1 text-sm cursor-pointer font-semibold"
              type="submit"
              variant="contained"
              size="large"
              onClick={() => setMoveToPickedDialogVisibility(false)}
            >
              <span>Cancel</span>
            </div>
            <button
              className={
                "border-green-600 bg-green-600 text-gray-100 border cursor-pointer rounded-md w-40 p-1 text-sm font-semibold"
              }
              type="submit"
              variant="contained"
              size="large"
              onClick={() => updateRequest()}
            >
              <span>Start Production</span>
            </button>
          </div>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
